import { css, html } from 'react-strict-dom';
import { color } from 'src/constants/color.css';

import { Api } from '../../../api';
import { Avatar, Text } from '../../../components';
import { Style } from '../../../constants';

type Props = {
  users: ReadonlyArray<Api.User.BaseView>;
  max?: number;
  size?: number;
};

export default function AvatarGroup({ users, max = 4, size = 32 }: Props) {
  if (users.length === 0) return null;

  const visible = users.slice(0, max);
  const overflow = users.length - max;

  return (
    <html.div style={[Style.row, Style.alignCenter]}>
      {visible.map((user, i) => (
        <html.div
          key={user.id}
          style={[styles.avatarWrap, i > 0 && styles.overlap]}
          aria-label={`${user.firstName} ${user.lastName}`}
        >
          <Avatar user={user} size={size} />
        </html.div>
      ))}
      {overflow > 0 && (
        <html.div
          style={[
            Style.row,
            Style.centerBoth,
            styles.overflowBadge,
            styles.overlap,
            styles.badgeSize(size),
          ]}
        >
          <Text style={styles.overflowBadgeText}>+{overflow}</Text>
        </html.div>
      )}
    </html.div>
  );
}

const styles = css.create({
  avatarWrap: {
    display: 'flex',
    borderRadius: '50%',
    borderWidth: 0.5,
    borderStyle: 'solid',
    borderColor: color.neutral20,
  },
  overlap: {
    marginInlineStart: -8,
  },
  overflowBadge: {
    borderRadius: '50%',
    backgroundColor: color.neutral10,
    color: color.neutral60,
    borderWidth: 0.5,
    borderStyle: 'solid',
    borderColor: color.neutral20,
  },
  overflowBadgeText: {
    fontSize: 12,
    fontWeight: '600',
  },
  badgeSize: (size: number) => ({
    width: size,
    height: size,
  }),
});
